<div [class]="'message-bubble bubble-' + message().role">
    @if (message().role === 'tool-progress') {
        <mat-icon class="tool-icon">build</mat-icon>
    }
    <span class="message-content">{{ message().content }}</span>
    @if (message().role === 'user') {
        <span class="message-time">{{ message().timestamp | date:'HH:mm' }}</span>
    }
</div>
